import amplitude from 'amplitude-js';

export default {
  event(name, payload) {
    console.warn(`Triggered amplitude event: ${name}. Params:`, payload);
    return amplitude.getInstance().logEvent(name, payload);
  },
};
